var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { getDictionary } from '@synisys/dictionary';
import { html, LitElement } from 'lit';
import { property, query, state } from 'lit/decorators.js';
import { SortInfo } from '../../shared/context-menu/item-search-sort';
import { getSupportedIconsMetadata } from '../../shared/icon/icon.metadata';
import { translate } from '../../utilities/translate';
import '../sds-icon-picker-item/sds-icon-picker-item.lit';
import { SdsIconPickerItem } from '../sds-icon-picker-item/sds-icon-picker-item.lit';
import '../sds-icon-picker-item/sds-icon-picker-none.lit';
import { SdsIconPickerNone } from '../sds-icon-picker-item/sds-icon-picker-none.lit';
import styles from './sds-inner-icon-picker.lit.scss';
import { sdsCustomElement } from '../../utilities/custom-components';
let SdsInnerIconPicker = (() => {
    var _SdsInnerIconPicker_value_accessor_storage, _SdsInnerIconPicker__contentContainer_accessor_storage, _SdsInnerIconPicker_iconsMetadata_accessor_storage, _SdsInnerIconPicker_searchValue_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-inner-icon-picker')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _value_decorators;
    let _value_initializers = [];
    let _value_extraInitializers = [];
    let __contentContainer_decorators;
    let __contentContainer_initializers = [];
    let __contentContainer_extraInitializers = [];
    let _iconsMetadata_decorators;
    let _iconsMetadata_initializers = [];
    let _iconsMetadata_extraInitializers = [];
    let _searchValue_decorators;
    let _searchValue_initializers = [];
    let _searchValue_extraInitializers = [];
    var SdsInnerIconPicker = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsInnerIconPicker_value_accessor_storage.set(this, __runInitializers(this, _value_initializers, void 0));
            _SdsInnerIconPicker__contentContainer_accessor_storage.set(this, (__runInitializers(this, _value_extraInitializers), __runInitializers(this, __contentContainer_initializers, void 0)));
            _SdsInnerIconPicker_iconsMetadata_accessor_storage.set(this, (__runInitializers(this, __contentContainer_extraInitializers), __runInitializers(this, _iconsMetadata_initializers, this.prepareIconsMetadata())));
            _SdsInnerIconPicker_searchValue_accessor_storage.set(this, (__runInitializers(this, _iconsMetadata_extraInitializers), __runInitializers(this, _searchValue_initializers, '')));
            this._selectedItem = __runInitializers(this, _searchValue_extraInitializers);
            this.itemClickHandler = (event) => {
                if (event.target instanceof SdsIconPickerItem) {
                    const clickedItem = event.target;
                    if (this._selectedItem instanceof SdsIconPickerNone) {
                        this._selectedItem.selected = false;
                    }
                    this._selectedItem = clickedItem;
                    this.value = clickedItem.value;
                    this.dispatchChange(this.value);
                }
                else if (event.target instanceof SdsIconPickerNone) {
                    this._selectedItem = event.target;
                    this.value = undefined;
                    this._selectedItem.selected = true;
                    this.dispatchChange();
                }
            };
            this.handleSearchInput = (event) => {
                this.searchValue = event.detail.value.trim();
            };
            this.handleSearchCleared = () => {
                this.searchValue = '';
            };
            this.changeLanguageHandler = () => {
                this.iconsMetadata = getSupportedIconsMetadata(24);
            };
        }
        get value() { return __classPrivateFieldGet(this, _SdsInnerIconPicker_value_accessor_storage, "f"); }
        set value(value) { __classPrivateFieldSet(this, _SdsInnerIconPicker_value_accessor_storage, value, "f"); }
        get _contentContainer() { return __classPrivateFieldGet(this, _SdsInnerIconPicker__contentContainer_accessor_storage, "f"); }
        set _contentContainer(value) { __classPrivateFieldSet(this, _SdsInnerIconPicker__contentContainer_accessor_storage, value, "f"); }
        get iconsMetadata() { return __classPrivateFieldGet(this, _SdsInnerIconPicker_iconsMetadata_accessor_storage, "f"); }
        set iconsMetadata(value) { __classPrivateFieldSet(this, _SdsInnerIconPicker_iconsMetadata_accessor_storage, value, "f"); }
        get searchValue() { return __classPrivateFieldGet(this, _SdsInnerIconPicker_searchValue_accessor_storage, "f"); }
        set searchValue(value) { __classPrivateFieldSet(this, _SdsInnerIconPicker_searchValue_accessor_storage, value, "f"); }
        render() {
            return html `
            <div class="sds-icon-picker">
                <div class="sds-icon-picker__header">
                    <sds-search
                        placeholder="${translate('sds.icon_picker.search.placeholder')}"
                        value="${this.searchValue}"
                        @sds.search.input="${this.handleSearchInput}"
                        @sds.search.cleared="${this.handleSearchCleared}"
                    ></sds-search>
                </div>
                ${this.renderContainer()}
            </div>
        `;
        }
        // region lifecycle
        scrollToSelected() {
            setTimeout(() => {
                this.findSelectedItem();
                if (this._selectedItem) {
                    requestAnimationFrame(() => {
                        var _a;
                        (_a = this._contentContainer) === null || _a === void 0 ? void 0 : _a.scroll({
                            top: this._selectedItem.offsetTop - 138,
                        });
                    });
                }
            }, 0);
        }
        resetSearch() {
            this.searchValue = '';
        }
        connectedCallback() {
            super.connectedCallback();
            getDictionary().addListener('languageChanged', this.changeLanguageHandler);
        }
        // endregion
        // region events
        disconnectedCallback() {
            getDictionary().removeListener('languageChanged', this.changeLanguageHandler);
            super.disconnectedCallback();
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        async firstUpdated() {
            await this.updateComplete;
            this.scrollToSelected();
        }
        renderContainer() {
            const items = this.iconsMetadata
                .map(item => {
                return {
                    item: item,
                    sortInfo: item.applySearchAndReturnSortInfo(this.searchValue),
                };
            })
                .filter(meta => meta.sortInfo.isFound())
                .sort((a, b) => SortInfo.compareFn(a.sortInfo, b.sortInfo));
            if (items.length === 0) {
                return html `
                <div class="sds-icon-picker__empty">
                    ${translate('sds.icon_picker.no_results')} "${this.searchValue}"
                </div>
            `;
            }
            else {
                return html `
                <div
                    id="content-container"
                    class="sds-icon-picker__container"
                    @click="${this.itemClickHandler}"
                >
                    ${this.renderItems(items)}
                </div>
            `;
            }
        }
        renderItems(items) {
            const itemTemplates = items.map(meta => {
                return html `
                <sds-icon-picker-item
                    value="${meta.item.identifier}"
                    name="${meta.item.displayName}"
                    ?selected="${this.value === meta.item.identifier}"
                ></sds-icon-picker-item>
            `;
            });
            if (this.searchValue.trim().length === 0) {
                itemTemplates.unshift(html ` <sds-icon-picker-none></sds-icon-picker-none>`);
            }
            return itemTemplates;
        }
        dispatchChange(iconIdentifier) {
            this.dispatchEvent(new CustomEvent(SdsInnerIconPicker.CHANGE_EVENT, {
                detail: {
                    selectedIcon: iconIdentifier,
                },
            }));
        }
        // endregion
        findSelectedItem() {
            var _a;
            (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll('sds-icon-picker-item').forEach((item) => {
                if (item.value === this.value) {
                    this._selectedItem = item;
                }
            });
        }
        prepareIconsMetadata() {
            return getSupportedIconsMetadata(24).sort((a, b) => a.displayName.localeCompare(b.displayName));
        }
    };
    _SdsInnerIconPicker_value_accessor_storage = new WeakMap();
    _SdsInnerIconPicker__contentContainer_accessor_storage = new WeakMap();
    _SdsInnerIconPicker_iconsMetadata_accessor_storage = new WeakMap();
    _SdsInnerIconPicker_searchValue_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsInnerIconPicker");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _value_decorators = [property()];
        __contentContainer_decorators = [query('#content-container')];
        _iconsMetadata_decorators = [state()];
        _searchValue_decorators = [state()];
        __esDecorate(_classThis, null, _value_decorators, { kind: "accessor", name: "value", static: false, private: false, access: { has: obj => "value" in obj, get: obj => obj.value, set: (obj, value) => { obj.value = value; } }, metadata: _metadata }, _value_initializers, _value_extraInitializers);
        __esDecorate(_classThis, null, __contentContainer_decorators, { kind: "accessor", name: "_contentContainer", static: false, private: false, access: { has: obj => "_contentContainer" in obj, get: obj => obj._contentContainer, set: (obj, value) => { obj._contentContainer = value; } }, metadata: _metadata }, __contentContainer_initializers, __contentContainer_extraInitializers);
        __esDecorate(_classThis, null, _iconsMetadata_decorators, { kind: "accessor", name: "iconsMetadata", static: false, private: false, access: { has: obj => "iconsMetadata" in obj, get: obj => obj.iconsMetadata, set: (obj, value) => { obj.iconsMetadata = value; } }, metadata: _metadata }, _iconsMetadata_initializers, _iconsMetadata_extraInitializers);
        __esDecorate(_classThis, null, _searchValue_decorators, { kind: "accessor", name: "searchValue", static: false, private: false, access: { has: obj => "searchValue" in obj, get: obj => obj.searchValue, set: (obj, value) => { obj.searchValue = value; } }, metadata: _metadata }, _searchValue_initializers, _searchValue_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsInnerIconPicker = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.CHANGE_EVENT = 'sds.inner-icon-picker.changed';
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsInnerIconPicker = _classThis;
})();
export { SdsInnerIconPicker };
